export const trpcPath = '/trpc';
